export enum ProcessState {
  NotStarted = 0,
  Started = 1,
  Succeeded = 2,
  Failed = 3
}
